import { GridCellProps } from '@progress/kendo-react-grid';
import React, { useContext } from 'react';
import { EditCellContext } from 'src/contexts/EditCellContext';
import { informationIcon } from 'src/utils/icons';

const PoLineItemInfoCell: React.ComponentType<GridCellProps> = (props) => {
  const [cellClick] = useContext(EditCellContext);
  const func = cellClick?.('');

  const handleClick = () => {
    if (props.dataItem.hasPoAccess) {
      func?.cellClick?.(props.dataItem);
    }
  };

  return (
    <td>
      {props.dataItem.hasPoAccess && (
        <div
          onClick={handleClick}
          className="flex justify-center items-center hover:cursor-pointer"
        >
          {informationIcon}
        </div>
      )}
    </td>
  );
};

export default PoLineItemInfoCell;
